import { Node } from 'slate';
import { useSlate } from 'slate-react';

const useLink = () => {
    const editor = useSlate();
    const { selection } = editor;

    const link = editor.getLink();

    const url = link?.[0]?.attributes.href || '';
    const text =
        (link && Node.string(link?.[0])) ||
        (selection && editor.string(selection));

    return { url, text };
};

export default useLink;
